/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/
import { useTranslation } from 'react-i18next';

import {ReactComponent as IconClose} from '../icons/close.svg';
 
 
import styles from '../styles/exitscreen.module.scss'
import { Code } from './Code';

interface ExitscreenProps {
    code: string | null;
    onCloseExitscreen: () => void;
    onQuit: () => void;
}

export function Exitscreen(props:ExitscreenProps) {
    const {t} = useTranslation();

    return (
        <div className={`${styles.background}`}>
            <div className={`${styles.container}`}>
                <p className={styles.title}>{t('exitscreen.title')}</p>
                <p className={styles.text} dangerouslySetInnerHTML={{__html: t('exitscreen.text')}}></p>
                <button className={`${styles.buttonSub} ${styles.buttonCircle} ${styles.buttonClose}`} onClick={() => {props.onCloseExitscreen()}}><IconClose/></button>
                <Code code={props.code}></Code>

                <div className={`${styles.buttonContainer}`}>
                    <button className={`${styles.button} ${styles.buttonPrimary}`} onClick={() => {props.onCloseExitscreen()}}>{t('exitscreen.cancel')}</button>
                    <button className={`${styles.button} ${styles.buttonSub}`} onClick={() => {props.onQuit()}}>{t('exitscreen.quit')}</button>
                </div>                
            </div>
        </div>
    );
};
 